import { api } from './api';

/**
 * Submit feedback (admin only)
 * @param {Object} data - { category, message, pageUrl, pageContext, userAgent }
 */
export const submitFeedback = async (data) => {
  const res = await api.post('/feedback', data);
  return res.data;
};

/**
 * Get list of feedback items with pagination and filters
 * @param {Object} params - { status, category, page, limit }
 */
export const getFeedbackList = async (params = {}) => {
  const res = await api.get('/feedback/list', { params });
  return res.data;
};

/**
 * Get count of unread (NEW status) feedback
 */
export const getUnreadCount = async () => {
  const res = await api.get('/feedback/unread-count');
  return res.data;
};

/**
 * Get a single feedback item by ID
 * @param {string} id - Feedback ID
 */
export const getFeedback = async (id) => {
  const res = await api.get(`/feedback/${id}`);
  return res.data;
};

/**
 * Update feedback status
 * @param {string} id - Feedback ID
 * @param {string} status - NEW, REVIEWED, or RESOLVED
 */
export const updateFeedbackStatus = async (id, status) => {
  const res = await api.patch(`/feedback/${id}/status`, { status });
  return res.data;
};

/**
 * Delete feedback
 * @param {string} id - Feedback ID
 */
export const deleteFeedback = async (id) => {
  const res = await api.delete(`/feedback/${id}`);
  return res.data;
};

const feedbackApi = {
  submitFeedback,
  getFeedbackList,
  getUnreadCount,
  getFeedback,
  updateFeedbackStatus,
  deleteFeedback,
};

export default feedbackApi;
